import { create } from "zustand";
import { IBondSecurity } from "@/lib/interfaces and Enums/ENUMBondSecurity";
import { ReferenceDataStatus } from "@/lib/interfaces and Enums/ENUMReferenceDataStatus";

// LQC-2254 - the bond universe a scratch-built block can reference, fetched on demand
// by the Leg Creation widget and by the Prices widget, which seeds its rows
// from it (see bondSecuritiesStoreACTIONS). This payload is large, so it is
// deliberately never fetched for a user who adds neither widget.

type State = {
  bondSecurities: IBondSecurity[];
  bondSecuritiesStatus: ReferenceDataStatus;
  bondSecuritiesError: string;
};

type Action = {
  // eslint-disable-next-line no-unused-vars
  setBondSecurities: (bondSecurities: IBondSecurity[]) => void;
  // eslint-disable-next-line no-unused-vars
  setBondSecuritiesStatus: (status: ReferenceDataStatus) => void;
  // eslint-disable-next-line no-unused-vars
  setBondSecuritiesError: (message: string) => void;
  clearBondSecurities: () => void;
};

const bondSecuritiesStore = create<State & Action>((set) => ({
  bondSecurities: [],
  bondSecuritiesStatus: ReferenceDataStatus.Idle,
  bondSecuritiesError: "",

  // A successful load is the only way to Loaded - it also clears any prior error.
  setBondSecurities: (bondSecurities) =>
    set({
      bondSecurities,
      bondSecuritiesStatus: ReferenceDataStatus.Loaded,
      bondSecuritiesError: "",
    }),
  setBondSecuritiesStatus: (bondSecuritiesStatus) =>
    set({ bondSecuritiesStatus }),
  setBondSecuritiesError: (bondSecuritiesError) =>
    set({
      bondSecuritiesError,
      bondSecuritiesStatus: ReferenceDataStatus.Error,
    }),
  clearBondSecurities: () =>
    set({
      bondSecurities: [],
      bondSecuritiesStatus: ReferenceDataStatus.Idle,
      bondSecuritiesError: "",
    }),
}));

export default bondSecuritiesStore;
